// const baseURL = 'https://localhost:44389/api/';
 const baseURL = 'https://api.LAECCTS.skgoas.in/api/';

export const LOGIN_URL = `${baseURL}Account/login`;
export const CIVILIDC_URL = `${baseURL}Masters/getcivilidcs`;
export const CIVILCEO_URL = `${baseURL}Masters/getcivilceos`;
export const GET_CIVILCEO_BY_IDC_ID = `${baseURL}Masters/getcivilceobyidcid`;
export const GET_CIVILSEO_BY_CEO_ID = `${baseURL}Masters/getcivilseobyceoid`;
export const GET_CIVIL_DIVISION_BY_SEO_ID = `${baseURL}Masters/getcivildivisionbyseoid`;
export const DISTRICTS_URL = `${baseURL}Masters/getdistricts`;
export const COURTS_URL = `${baseURL}Masters/getcourts`;
export const DESIGNATION_URL = `${baseURL}Masters/getdesignations`;
export const GET_DESIGNATION_BY_ID = `${baseURL}Masters/getdesignationbyid`;
export const ADD_UPDATE_DESIGNATION = `${baseURL}Masters/addeditdesignation`;
export const USERS_URL = `${baseURL}Masters/getusers`;
export const GET_ACTIVE_USERS = `${baseURL}Masters/getactiveusers`;
export const GET_USER_BY_ID = `${baseURL}Masters/getuserbyid`;
export const ADD_UPDATE_USER = `${baseURL}Masters/addedituser`;
export const GET_LEGAL_ADVISORS = `${baseURL}Masters/getlegaladvisors`;
export const GET_ADVOCATES = `${baseURL}Masters/getadvocates`;
export const PROJECT_URL = `${baseURL}Masters/getprojects`;
export const GET_PROJECT_BY_ID = `${baseURL}Masters/getprojectbyid`;
export const ADD_UPDATE_PROJECT = `${baseURL}Masters/addeditproject`;
export const CASE_TYPE_URL = `${baseURL}Masters/getcasetypes`;
export const GET_CASE_TYPE_BY_COURT_ID = `${baseURL}Masters/getcasetypebycourtid`;
export const GET_CASE_TYPE_BY_ID = `${baseURL}Masters/getcasetypebyid`;
export const ADD_UPDATE_CASE_TYPE = `${baseURL}Masters/addeditcasetype`;
export const CASE_STAGE_URL = `${baseURL}Masters/getcasestages`;
export const GET_CASE_STAGE_BY_TYPE_ID = `${baseURL}Masters/getcasestagebytypeid`;
export const GET_CASE_STAGE_BY_ID = `${baseURL}Masters/getcasestagebyid`;
export const ADD_UPDATE_CASE_STAGE = `${baseURL}Masters/addeditcasestage`;
export const CASE_STATUS_URL = `${baseURL}Masters/getcasestatuses`;
export const GET_CASE_STATUS_BY_ID = `${baseURL}Masters/getcasestatusbyid`;
export const ADD_UPDATE_CASE_STATUS = `${baseURL}Masters/addeditcasestatus`;


export const GET_CASE_DETAILS_BY_TYPE_ID = `${baseURL}Work/getcasedetailsbytypeid`;
export const GET_CASE_DETAILS_BY_CASE_TYPE_ID = `${baseURL}Work/getcasedetailsbycasetypeid`;
export const GET_CASE_DETAILS_BY_ADVOCATE_ID = `${baseURL}Work/getcasedetailsbyadvocateid`;
export const GET_CASE_DETAILS_BY_ID = `${baseURL}Work/getcasedetailsbyid`;
export const ADD_UPDATE_CASE_DETAILS = `${baseURL}Work/addeditcasedetails`;

export const GET_CASE_STAGE_DETAILS_BY_CASE_ID = `${baseURL}Work/getcasestagedetailsbycaseid`;
export const GET_CASE_STAGE_DETAILS_BY_ID = `${baseURL}Work/getcasestagedetailsbyid`;
export const ADD_UPDATE_CASE_STAGE_DETAILS = `${baseURL}Work/addeditcasestagedetails`;

export const GET_CASE_STATUS_DETAILS_BY_CASE_ID = `${baseURL}Work/getcasestatusdetailsbycaseid`;
export const GET_CASE_STATUS_DETAILS_BY_ID = `${baseURL}Work/getcasestatusdetailsbyid`;
export const ADD_UPDATE_CASE_STATUS_DETAILS = `${baseURL}Work/addeditcasestatusdetails`;

export const GET_LEGAL_ADVISOR_ALLOCATIONS = `${baseURL}Work/getlegaladvisorallocations`;
export const DELETE_LEGAL_ADVISOR_ALLOCATIONS = `${baseURL}Work/deletelegaladvisorallocation`;
export const ADD_LEGAL_ADVISOR_ALLOCATION = `${baseURL}Work/addlegaladvisorallocation`;

export const GET_ADVOCATE_ALLOCATIONS = `${baseURL}Work/getadvocateallocations`;
export const DELETE_ADVOCATE_ALLOCATIONS = `${baseURL}Work/deleteadvocateallocation`;
export const ADD_ADVOCATE_ALLOCATION = `${baseURL}Work/addadvocateallocation`;

export const DOWNLOAD_FILE = `${baseURL}Work/downloadfile`;
export const GET_DIVISION_WISE_ABSTRACT_LA = `${baseURL}Report/getdivisionwiseabstractla`;

export default LOGIN_URL;